import ToggleSwitch from "./ToggleSwitch";
import "./VocabTooltip.css";
import "./GameStatsModeSwitch.css";

export default function GameStatsModeSwitch({ mode = "vocab", onChange }) {
  const isMemory = mode === "memory";

  return (
    <div className="game-stats-mode-switch" role="group" aria-label="Type de parties affichées">
      <span
        className={`game-stats-mode-switch__label game-stats-mode-switch__label--left${
          isMemory ? "" : " game-stats-mode-switch__label--active"
        }${isMemory ? " vocab-tooltip-wrap" : ""}`}
      >
        {isMemory ? "V" : "jeux de vocabulaire"}
        {isMemory ? (
          <span className="vocab-tooltip" role="tooltip">
            Jeux de vocabulaire
          </span>
        ) : null}
      </span>
      <ToggleSwitch
        compact
        alwaysCheckedLook
        className="game-stats-mode-switch__toggle"
        checked={isMemory}
        onChange={(checked) => onChange(checked ? "memory" : "vocab")}
        aria-label={
          isMemory ? "Afficher le jeu de mémoire" : "Afficher les jeux de vocabulaire"
        }
      />
      <span
        className={`game-stats-mode-switch__label game-stats-mode-switch__label--right${
          isMemory ? " game-stats-mode-switch__label--active" : " vocab-tooltip-wrap"
        }`}
      >
        {isMemory ? "jeux de mémoire" : "M"}
        {isMemory ? null : (
          <span className="vocab-tooltip" role="tooltip">
            Jeux de mémoire
          </span>
        )}
      </span>
    </div>
  );
}
